import React from 'react';
import {Outlet} from "react-router-dom";

import css from './SettingsPage.module.css';
import {TitleMenuSettings} from "../../components/settingsSection";


const SettingsPage = () => {


    return (
        <section className={css.wrap}>
            <section className={css.menuBlock}>
                <TitleMenuSettings/>
            </section>

            <section className={css.outletBlock}>
                <Outlet/>
            </section>
        </section>
    );
};

export {SettingsPage};